<div class="network-status-renderer">
  <div class="network-status-renderer__icon">
    <img [src]="iconUrl()" />
  </div>
  <div class="network-status-renderer__text">
    <div class="network-status-renderer__name" [innerHTML]="highlightedName()"></div>
    @if (highlightedMeta().show) {
      <div class="network-status-renderer__meta">
        @if (highlightedMeta().county) {
          <span [innerHTML]="highlightedMeta().county"> </span>
        }
        @if (highlightedMeta().showDot) {
          <span class="network-status-renderer__dot">·</span>
        }

        @if (highlightedMeta().association) {
          <span [innerHTML]="highlightedMeta().association"> </span>
        }
      </div>
    }
  </div>
  <div class="network-status-renderer__favorite">
    @if (params().data.Favorite) {
      <span class="material-icons network-status-renderer__favorite-icon filled">favorite</span>
    }
  </div>
</div>
